import { usePermission } from './PermissionProvider'
import { ACTIONS, actionToBackendPermissionMap } from '../components/PermissionMapper/constants'
import React from 'react'

interface ProtectedContentProps {
  actions?: ACTIONS[]
  requireAll?: boolean
  showContent?: boolean
  fallback?: React.ReactElement
  children: React.ReactElement
}

export function ProtectedContent(props: ProtectedContentProps): React.ReactElement {
  const { actions = [], requireAll, showContent = true, fallback = <></>, children } = props

  const { hasAction, hasNavAction } = usePermission()

  let hasAccess = false

  const checkAction = (action: ACTIONS) => {
    return actionToBackendPermissionMap[action] ? hasAction(action) : hasNavAction(action)
  }

  if (actions.length > 0) {
    hasAccess = requireAll
      ? actions.every((action) => checkAction(action))
      : actions.some((action) => checkAction(action))
  }

  if (!hasAccess || !showContent) {
    return fallback
  }

  return children
}
